import Link from 'next/link';

const footerLinks = [
  { id: 'footer_about', label: 'About', href: '/homepage#about' },
  { id: 'footer_methodology', label: 'Methodology', href: '/homepage#methodology' },
  { id: 'footer_contribute', label: 'Contribute', href: '/homepage#contribute' },
  { id: 'footer_contact', label: 'Contact', href: '/homepage#contact' },
]

export default function Footer() {
  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto max-w-7xl px-6 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <div className="font-mono text-sm text-muted-foreground">
            s4playbook.com
          </div>

          {/* Links */}
          <div className="flex items-center gap-6">
            {footerLinks?.map((link) => (
              <Link
                key={link?.id}
                href={link?.href}
                className="text-sm font-mono text-muted-foreground hover:text-foreground transition-colors"
              >
                {link?.label}
              </Link>
            ))}
          </div>

          {/* Legal */}
          <div className="flex items-center gap-4 text-xs font-mono text-muted-foreground">
            <span>MIT License</span>
            <span>·</span>
            <span>© 2026</span>
          </div>
        </div>
      </div>
    </footer>
  );
}